import type { SystemMessage } from "@js/types/messenger";
import {
  ExpectedMessageReportedResults,
  ExpectedReportsCancelledResults,
  ExpectedUserReportedResults,
} from "@js/types/messenger";
import { assertUnreachable } from "@js/utils";

import { ReportSystemMessageCard } from "./report-system-message-card";

type SystemMessageCardProps = {
  message: SystemMessage;
};

// null if card does not exist e.g. USER_MESSAGE
export const SystemMessageCard = ({ message }: SystemMessageCardProps) => {
  const messageType = message.message_type;

  switch (messageType) {
    case ENUMS.MessageType.USER_REPORTED: {
      const parsedResults = ExpectedUserReportedResults.parse(
        message.system_message_target,
      );

      return <ReportSystemMessageCard name={parsedResults.public_name} />;
    }

    case ENUMS.MessageType.MESSAGE_REPORTED: {
      const parsedResults = ExpectedMessageReportedResults.parse(
        message.system_message_target,
      );

      return (
        <ReportSystemMessageCard name={parsedResults.author.public_name} />
      );
    }

    case ENUMS.MessageType.USER_REPORTS_CANCELLED: {
      const parsedResults = ExpectedReportsCancelledResults.parse(
        message.system_message_target,
      );

      return (
        <ReportSystemMessageCard
          name={parsedResults.public_name}
          cancelledReport
        />
      );
    }

    case ENUMS.MessageType.OFFER_EXTENDED: {
      // handled as regular message with additional data
      return null;
    }

    default:
      assertUnreachable(messageType);
      return null;
  }
};
